import React, { useState } from "react";
import ReservationSearch from "../../components/Reservation/ReservationSearch";
import CheckQRCode from "../../components/Utils/CheckQRCode";
import { t } from "@lingui/macro";

const ReservationPage = () => {
  const [activeTab, setActiveTab] = useState("search"); 

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1>{t`Reservation Dashboard`}</h1>
      </div>

      <div className="dashboard-tabs">
        <button
          className={`tab ${activeTab === "search" ? "active" : ""}`}
          onClick={() => handleTabChange("search")}
        >
          {t`Search Reservations`}
        </button>
        <button
          className={`tab ${activeTab === "qrcode" ? "active" : ""}`}
          onClick={() => handleTabChange("qrcode")}
        >
          {t`Check QR Code`}
        </button>
      </div>

      <div className="dashboard-content">
        {activeTab === "search" && <ReservationSearch />}
        {activeTab === "qrcode" && <CheckQRCode />}
      </div>
    </div>
  );
};

export default ReservationPage;
